import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
}) => {
  const { currentUser, isAdmin, loading } = useAuth();

  // Wait for authentication to be initialized
  if (loading) {
    return null; // Or return a loading spinner
  }

  // Check if user is not logged in
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Check if admin access is required but user is not admin
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/404" />;
  }

  return <>{children}</>;
};
